import { PaginationWrapper } from '@Components/LandingPage/FilterSection/FilterSection.styled';
import Pagination from '@Components/Pagination';
import ProductCard from '@Components/ProductCard';
import ProductCardLoader from '@Components/ProductCard/ProductCard.loader';
import RequestCustomItem from '@Components/RequestCustomItem';
import useTranslation from 'next-translate/useTranslation';
import { Fragment, useState } from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { APIResponse } from 'types/APIResponse';
import { Product } from 'types/Products';
import { RelatedList, Section, Title } from './RelatedProductsSection.styled';

type Props = {
  products: APIResponse<Product[]>;
  isLoading: boolean;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  totalProducts: number;
};

export default function RelatedProductsSection({ products, isLoading, setOffset, totalProducts }: Props) {
  const { t } = useTranslation('Product');
  const [current, setCurrent] = useState<number>(1);

  return (
    <Section>
      <Container>
        <Row justifyContent="center">
          <Col col={12} lg={11}>
            <Title>{t('related_products')}</Title>
          </Col>
          <Col col={12} lg={11}>
            <RelatedList>
              {products ? (
                Boolean(products?.results.length) ? (
                  <Fragment>
                    {products.results.map((product) => (
                      <ProductCard data={product} key={product.id + '_PRODUCT_BEST_SELLER'} />
                    ))}
                  </Fragment>
                ) : (
                  <RequestCustomItem />
                )
              ) : (
                [...new Array(4)].map((_, i) => <ProductCardLoader key={i + '_LANDING_BEST_SELLERS'} />)
              )}
            </RelatedList>
            {Boolean(totalProducts) && (
              <PaginationWrapper
                style={{
                  justifyContent: 'center',
                }}
              >
                <Pagination
                  total={totalProducts}
                  disabled={isLoading}
                  defaultPageSize={4}
                  pageSize={4}
                  defaultCurrent={1}
                  current={current}
                  showPrevNextJumpers={true}
                  showQuickJumper={false}
                  onChange={(pageNum: number) => {
                    setOffset(4 * (pageNum - 1));
                    setCurrent(pageNum);
                  }}
                />
              </PaginationWrapper>
            )}
          </Col>
        </Row>
      </Container>
    </Section>
  );
}
